// native
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

// service
import { ApiService } from 'app/core/services/api.service';

// models
import { HomeSetup, HomeSetupRequest } from '../models';

// constants
import { API_HOME_SETUPS_PATH } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class HomeManagementService {

  constructor(private apiService: ApiService) { }

  create(body: HomeSetupRequest): Observable<HomeSetup> {
    return this.apiService.post(API_HOME_SETUPS_PATH, body).pipe(map(res => res as HomeSetup));
  }
}
